
export default {
  props: {
    header: { type: Object, required: true },
    filters: { type: Array, required: true },
    filterHeight: { type: Number, required: true },
    pagination: { type: Object, required: true },
    fixedCol: { type: String, default: null },
    activator: { type: String, required: true },
    noFix: { type: Boolean, default: false },
    localEnum: { type: Array, required: false, default: null },
    closeOnFilter: { type: Boolean, default: false }
  },
  data () {
    return {
      showMenu: false,
      equals: [],
      startsWith: '',
      search: '',
      contains: '',
      equalsBool: null,
      lte: null,
      gte: null,
      editDate: null,
      showHelp: false
    }
  },
  computed: {
    field () {
      return this.header.field
    },
    fullEnum () {
      if (!this.showEnum) return
      const fullEnum = []
      if (this.localEnum) {
        for (const value of this.localEnum) {
          fullEnum.push({ value, important: true })
        }
      }
      if (this.field.enum) {
        for (const value of this.field.enum.slice().sort()) {
          if (!this.localEnum || !this.localEnum.includes(value)) fullEnum.push({ value })
        }
      }
      return fullEnum
    },
    showEnum () {
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      if (this.localEnum) return true
      return this.field.enum && this.field['x-cardinality'] > 1
    },
    enumDense () {
      return this.showEnum && this.fullEnum.length > 4
    },
    showEquals () {
      if (this.showEnum) return false
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      if (this.field['x-refersTo'] === 'https://purl.org/geojson/vocab#geometry') return false
      if (this.field.type === 'string' && (!this.field.format || this.field.format === 'uri-reference')) return true
      if (this.field.type === 'number' || this.field.type === 'integer') return true
      return false
    },
    showBoolEquals () {
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      return !this.showEnum && this.field.type === 'boolean'
    },
    showStartsWith () {
      return this.field.type === 'string' && this.showEquals && !this.field['x-labels']
    },
    showNumCompare () {
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      return this.field.type === 'integer' || this.field.type === 'number'
    },
    showDateCompare () {
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      return this.field.type === 'string' && (this.field.format === 'date' || this.field.format === 'date-time')
    },
    showSearch () {
      if (this.showEnum) return false
      if (this.field['x-labels']) return false
      if (this.field.type !== 'string') return false
      if (this.field.format && this.field.format !== 'uri-reference') return false
      if (!this.field['x-capabilities'] || this.field['x-capabilities'].text !== false || this.field['x-capabilities'].textStandard !== false) return true
      return false
    },
    showContains () {
      return this.field['x-capabilities'] && this.field['x-capabilities'].wildcard && !this.field['x-labels']
    },
    active () {
      return !!this.filters.find(f => f.field.key === this.field.key)
    },
    reversedLabels () {
      const reversedLabels = {}
      for (const key of Object.keys(this.field['x-labels'] || {})) {
        reversedLabels[this.field['x-labels'][key]] = key
      }
      return reversedLabels
    },
    sortItem () {
      if (this.pagination.sortBy[0] !== this.header.value) return null
      return this.pagination.sortDesc[0] ? 1 : 0
    }
  },
  watch: {
    equals: {
      handler () {
        if (!this.showEquals) return
        const equals = this.equals.filter(v => !!v).concat([''])
        if (JSON.stringify(equals) !== JSON.stringify(this.equals)) this.equals = equals
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    toggledMenu () {
      if (!this.showMenu) return
      this.emptyFilters()
      const filters = this.filters.filter(f => f.field.key === this.field.key)
      for (const filter of filters) {
        if ('minValue' in filter && filter.minValue !== '*') this.gte = filter.minValue
        if ('maxValue' in filter && filter.maxValue !== '*') this.lte = filter.maxValue
        if (filter.type === 'starts') this.startsWith = filter.value
        if (filter.type === 'search') this.search = filter.value
        if (filter.type === 'contains') this.contains = filter.value
        if (filter.type === 'in' && filter.values && filter.values.length) {
          if (this.field.type === 'string' || this.field.type === 'number' || this.field.type === 'integer') {
            this.equals = [...filter.values]
            if (this.field['x-labels']) {
              this.equals = this.equals.map(v => this.field['x-labels'][v] ?? v)
            }
          }
          if (this.field.type === 'boolean') this.equalsBool = filter.values[0]
        }
      }
    },
    toggleEquals (value) {
      if (this.equals.includes(value)) this.equals = this.equals.filter(v => v !== value)
      else this.equals.push(value)
      this.emitFilter({ type: 'in', values: this.equals }, false)
    },
    emitIntervalFilter () {
      if (!this.gte && !this.lte) return
      this.emitFilter({
        type: 'interval',
        minValue: this.gte,
        maxValue: this.lte
      })
    },
    emitFilter (filter, close = true) {
      if (filter.type === 'in') {
        filter.values = filter.values.filter(v => !!v)
        if (this.field['x-labels']) {
          filter.values = filter.values.map(v => this.reversedLabels[v] ?? v)
        }
      }
      this.$emit('filter', filter)
      if (close || this.closeOnFilter) {
        this.showMenu = false
      }
    },
    emptyFilters () {
      this.equals = []
      this.startsWith = ''
      this.search = ''
      this.contains = ''
      this.equalsBool = null
      this.lte = null
      this.gte = null
      this.editDate = null
    },
    toggleSort (desc) {
      if (this.pagination.sortBy[0] === this.header.value && this.pagination.sortDesc[0] === desc) {
        this.$set(this.pagination, 'sortBy', [])
        this.$set(this.pagination, 'sortDesc', [])
      } else {
        this.$set(this.pagination, 'sortBy', [this.header.value])
        this.$set(this.pagination, 'sortDesc', [desc])
      }
      this.showMenu = false
    }
  }
}
